<template>
  <div>
    <section-header heading="2" ja="メールアドレス"></section-header>
    <div class="mailAddress">{{ mailAddress }}</div>

    <section-header heading="2" ja="パスワードを設定する"></section-header>
    <div class="textArea">英大文字・英小文字・数字をそれぞれ1文字以上含む8文字以上のパスワードを設定してください</div>
    <p-text-field
      placeholder="パスワード"
      type="password"
      v-model="password1">
    </p-text-field>
    <p-text-field
      placeholder="パスワード（再入力）"
      type="password"
      v-model="password2">
    </p-text-field>
    <rule v-if="!validPasswordRule">
      大小英字と数字を含む8文字以上127文字以下で入力してください
    </rule>
    <rule v-if="validPasswordRule && password1 && password1 !== password2">
      入力されたパスワードが一致しません
    </rule>
    <normal-btn @click="onOK" :disabled="!validForm">決定</normal-btn>
  </div>
</template>

<script>
  import NormalBtn from '../components/NormalBtn'
  import PTextField from "../components/PTextField";
  import Rule from "../components/Rule";
  import SectionHeader from '../components/SectionHeader.vue'
  import Protobuf from '../mixins/protobuf'
  import Screen from '../mixins/screen'
  import Validator from '../mixins/validator'


  const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
  export default {
    components: { NormalBtn, PTextField, Rule, SectionHeader },
    mixins: [ Protobuf, Screen, Validator ],
    data () {
      return {
        modal: false,
        mailAddress: '',
        password1: '',
        password2: '',
        passwordRules: [],
        okBtnDisabled: true,
        validateKey: ""
      }
    },
    computed: {
      validForm() {
        let err = this.validPassword(this.password1)
        if (err !== null) {
          return false
        }
        err = this.validPassword(this.password2)
        if (err !== null) {
          return false
        }
        return true
      },
      validPasswordRule() {
      let err = this.validPassword(this.password1)
      if (err !== null) {
        return false
      }
      return true
    },
      passwordRule() {
        return this.passwordRules.length > 0 ? this.passwordRules[0] : ''
      }
    },
    methods: {
      validatePassword1() {
        this.passwordRules = []
        const err = this.validPassword(this.password1)
        if (err !== null) {
          this.passwordRules.push(err.message)
        }
      },
      validatePassword2() {
        this.passwordRules = []
        let err = this.validPassword(this.password1)
        if (err !== null) {
          this.passwordRules.push(err.message)
          return
        }
        err = this.samePassword(this.password1, this.password2)
        if (err !== null) {
          this.passwordRules.push(err.message)
          return
        }
      },
      onOK () {
        this.$router.push({ name: 'mailAddressChangeFinish',
          params: {
          password: this.password1
          },
          query: {
          validateKey: this.validateKey
          }
        })
      }
    },
    mounted () {
      this.validateKey = this.$route.query.validateKey
      const cmdNo = pb.PlayerValidateKeyCheckReq.CommandNo.COMMAND_NO
      const message = pb.PlayerValidateKeyCheckReq.create({
        validateKey: this.$route.query.validateKey
      })
      const encoded = pb.PlayerValidateKeyCheckReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerValidateKeyCheckResp.Status.SUCCESS) {
            this.mailAddress = decoded.mailAddress
          } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.FAILED) {
            this.$_error('Error', { title: 'アカウントで登録', statusCode: 403 })
          } else if(decoded.status === pb.PlayerValidateKeyCheckResp.Status.EXPIRED) {
            this.$_error('Error', { title: 'アカウントで登録', statusCode: 402 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'アカウントで登録', statusCode: 100 })
        })
    }
  }
</script>

<style scoped>
.mailAddress {
  font-size: 14px;
  color: #373737;
  margin: 30px 30px 0;
}
.textArea {
  padding: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
